
import { defineComponent, nextTick, onBeforeMount, watch } from "vue";
import { useRoute } from "vue-router";

const __default__ = defineComponent({
  name: "Search",
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: ""
    },
    searchBarText: {
      type: String,
      required: true
    },
    height: {
      type: String,
      required: false,
      default: "30px"
    },
    fontSize: {
      type: String,
      required: false
    }
  },
  setup(props, { emit }) {
    const route = useRoute();
    let searchBarInput: HTMLInputElement;
    let debounceTimeout: ReturnType<typeof setTimeout>;

    onBeforeMount(async () => {
      await nextTick(() => {
        searchBarInput = document.querySelector(
            "[data-search-bar]"
        ) as HTMLInputElement;
        if (route.query.search) {
          searchBarInput.value = route.query.search.toString();
        } else {
          searchBarInput.value = "";
        }
        searchBarInput.focus();
      });
    });

    watch(
        () => route.query.search,
        () => {
          if (route.query.search) {
            searchBarInput.value = route.query.search.toString();
          } else {
            searchBarInput.value = "";
          }
          searchBarInput.focus();
        }
    );

    /** Emits an event passing the string input by the user with 500ms debounce. */
    const search = (event: Event) => {
      const input = event.target as HTMLInputElement;
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(() => {
        emit("searching", input.value.trim());
      }, 500);
    };

    return {
      search
    };
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "361ee0ca": (_ctx.height),
  "745b93d3": (_ctx.fontSize)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__